import { Dispatch } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { RootState } from 'store';

import { captureSocketMessage } from './socketMessagesLogger';

type SocketDispatcherMiddlewareApi = { dispatch: Dispatch; getState: () => RootState };

export type SocketDispatcherMiddlewareType = (
  api: SocketDispatcherMiddlewareApi,
  args: { path: string; payload: unknown }
) => boolean;

const socketDispatcherMiddlewares: SocketDispatcherMiddlewareType[] = [];

export const addSocketDispatcherMiddleware = (dispatcher: SocketDispatcherMiddlewareType) =>
  socketDispatcherMiddlewares.push(dispatcher);

export const initSocketMessageDispatcher =
  (api: SocketDispatcherMiddlewareApi) =>
  ({ path, payload }: { path: string; payload: unknown }) => {
    let handled = false;
    try {
      captureSocketMessage({ path, payload, type: 'INCOMING' });
      handled = socketDispatcherMiddlewares.some((dispatcher) => dispatcher(api, { path, payload }));
    } catch (error) {
      logger.error('[SocketMessageDispatcher] Error while handling WS message', { path, payload }, error);
      handled = false;
    } finally {
      if (!handled) {
        api.dispatch({
          type: path,
          payload,
        });
      }
    }
  };
